
<!--START : Card-->
<div
	class="card"
	:data-type="type"
	:data-background="background"
	:data-separator="separator"
	:data-clickable="clickable"
	:data-selected="selected"
	:data-disabled="disabled"
>
	<div v-if="$slots['header']" class="card-header">
		<slot name="header" />
	</div>
	<div class="card-content">
		<slot />
	</div>
	<div v-if="$slots['footer']" class="card-footer">
		<slot name="footer" />
	</div>
	<div v-if="loadingIcon" class="card-loader">
		<Container direction="column" :gap="12" :padding="0" align="center">
			<Icon
				:name="loadingIcon.name"
				:state="loadingIcon.state"
				:type="loadingIcon.type"
				:size="loadingIcon.size"
			/>
			<Typography v-if="loadingText" type="p2" weight="medium" color="dark">
				{{ loadingText }}
			</Typography>
		</Container>
	</div>
</div>
<!--END : Card-->
